import { namespace } from './namespace';

export const SELECT_OPTION = namespace + '/SELECT_OPTION';
export const SET_OPTION_PENDING = namespace + '/SET_OPTION_PENDING';
export const UNSET_OPTION_PENDING = namespace + '/UNSET_OPTION_PENDING';
export const UPDATE_CUSTOM_OPTION = namespace + '/UDPATE_CUSTOM_OPTION';
export const SHUFFLE_OPTIONS = namespace + '/SHUFFLE_OPTIONS';
export const REVERSE_OPTIONS = namespace + '/REVERSE_OPTIONS';
